<div class="ac-page">

  <!-- Header -->
  <div class="ac-page-header">
    <div class="ac-page-header__left">
      <div class="ac-page-header__icon"><mat-icon>menu</mat-icon></div>
      <div>
        <h1 class="ac-page-header__title">Diario contable</h1>
        <p class="ac-page-header__sub">Consulta y gestión de asientos</p>
      </div>
    </div>
  </div>

  <!-- Toolbar de filtros -->
  <div class="ac-toolbar">
    <div class="ac-toolbar__fields">

      <app-select [formControl]="monthFromFilterPagination" [config]="{ label: 'Desde', options: monthsOptions }"></app-select>

      <app-select [formControl]="monthToFilterPagination" [config]="{ label: 'Hasta', options: monthsOptions }"></app-select>

      <app-input inputType="number" placeholder="Importe" name="amountFilter" style="max-width:130px" [(ngModel)]="amountFilter" (keydown.enter)="keyDownEnterPress($event)"></app-input>

      <app-input inputType="text" placeholder="Descripción" name="descriptionFilter" style="max-width:180px" [(ngModel)]="descriptionFilter" (keydown.enter)="keyDownEnterPress($event)"></app-input>

      <app-input inputType="text" placeholder="Cuenta contable" name="accountFilter" style="max-width:150px" [(ngModel)]="accountFilter" (keydown.enter)="keyDownAccountNumberEnterPress($event)"></app-input>

      <app-input inputType="text" placeholder="Asiento" name="seatFilter" style="max-width:120px" [(ngModel)]="seatFilter" (keydown.enter)="keyDownEnterPress($event)"></app-input>

      <app-input inputType="date" placeholder="Fecha" name="dateFilter" style="max-width:150px" [(ngModel)]="dateFilter" (keydown.enter)="keyDownEnterPress($event)"></app-input>

      <mat-slide-toggle [formControl]="globalFilterPagination">Todas las actividades</mat-slide-toggle>

    </div>

    <div class="ac-toolbar__actions">
      <button mat-flat-button class="ac-btn-primary" (click)="filterAccountMovements()">
        <mat-icon>search</mat-icon> Consultar
      </button>
      <button mat-stroked-button class="ac-btn-export" (click)="excelAccountMovements()">
        <mat-icon>file_download</mat-icon> Excel
      </button>
      <button mat-stroked-button class="ac-btn-export" (click)="addManualAccountMovements()">
        <mat-icon>add</mat-icon> Asiento manual
      </button>
      <button mat-stroked-button class="ac-btn-export" (click)="excelAccountingImbalance()">
        <mat-icon>find_in_page</mat-icon> Buscar descuadre
      </button>

      <!-- Opciones de regularización / cierre -->
      <ng-container *ngIf="readyOptions">
        <ng-container *ngIf="spinnerReady">
          <span class="ac-inline-dots"><span></span><span></span><span></span></span>
        </ng-container>
        <button mat-stroked-button *ngIf="flagCheck.regularizacion" (click)="regularizacion()">Regularización</button>
        <button mat-stroked-button *ngIf="flagCheck.undoRegularizacion && flagCheck.cierre" (click)="undoRegularizacion()">Deshacer Regularización</button>
        <button mat-stroked-button *ngIf="flagCheck.cierre" (click)="cierre()">Cierre</button>
        <button mat-stroked-button *ngIf="flagCheck.undoCierre" (click)="undoCierre()">Deshacer Cierre</button>
        <button mat-stroked-button *ngIf="flagCheck.apertura" (click)="apertura()">Apertura</button>
        <button mat-stroked-button *ngIf="flagCheck.undoApertura" (click)="undoApertura()">Deshacer Apertura</button>
      </ng-container>
    </div>
  </div>

  <!-- Loading inline -->
  <div class="ac-loading" *ngIf="isLoadingResults">
    <div class="ac-loading__icon"><mat-icon>menu</mat-icon></div>
    <div class="ac-loading__dots"><span></span><span></span><span></span></div>
    <p class="ac-loading__text">Cargando asientos…</p>
  </div>

  <!-- Tabla -->
  <div class="ac-table-wrap" [hidden]="isLoadingResults">
    <div class="table-responsive">
      <table mat-table [dataSource]="data" class="table table-bordered w-100">

        <ng-container matColumnDef="accountNumber">
          <th mat-header-cell *matHeaderCellDef>Cuenta</th>
          <td mat-cell *matCellDef="let row" class="accountNumber hover-ledger"
            [ngClass]="{'is-odd': row.accountEntry % 2 === 0, 'cierre': row.isCierre, 'regularizado': row.isRegularizado, 'apertura': row.isApertura}"
            (click)="ledger(row.accountingModelsId, row.accountName, row.accountNumber)">
            {{ row.accountNumber }}
          </td>
        </ng-container>

        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef>Concepto</th>
          <td mat-cell *matCellDef="let row" [ngClass]="{'is-odd': row.accountEntry % 2 === 0}">
            <span *ngIf="row.description.includes('Gasto')" (click)="downloadFilePdf(row.description)" class="ac-desc-link">{{ row.description }}</span>
            <span *ngIf="!row.description.includes('Gasto')">{{ row.description }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="reference">
          <th mat-header-cell *matHeaderCellDef>Factura/Gasto</th>
          <td mat-cell *matCellDef="let row" [ngClass]="{'is-odd': row.accountEntry % 2 === 0}">{{ row.reference }}</td>
        </ng-container>

        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Fecha</th>
          <td mat-cell *matCellDef="let row" [ngClass]="{'is-odd': row.accountEntry % 2 === 0}">{{ row.date | date:'dd/MM/yyyy' }}</td>
        </ng-container>

        <ng-container matColumnDef="accountEntry">
          <th mat-header-cell *matHeaderCellDef>Asiento</th>
          <td mat-cell *matCellDef="let row" [ngClass]="{'is-odd': row.accountEntry % 2 === 0}">{{ row.accountEntry }}</td>
        </ng-container>

        <ng-container matColumnDef="debit">
          <th mat-header-cell *matHeaderCellDef>Debe</th>
          <td mat-cell *matCellDef="let row" [ngClass]="{'is-odd': row.accountEntry % 2 === 0}" style="text-align:right;font-variant-numeric:tabular-nums">
            {{ row.entryType === true ? row.amount : '0.00' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="credit">
          <th mat-header-cell *matHeaderCellDef>Haber</th>
          <td mat-cell *matCellDef="let row" [ngClass]="{'is-odd': row.accountEntry % 2 === 0}" style="text-align:right;font-variant-numeric:tabular-nums">
            {{ row.entryType === false ? -row.amount : '0.00' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Asiento manual</th>
          <td mat-cell *matCellDef="let row" style="text-align:center">
            <ng-container *ngIf="row.manual === true">
              <button mat-icon-button [matMenuTriggerFor]="actionsMenu" (click)="actionRowClicked(row)">
                <mat-icon>more_vert</mat-icon>
              </button>
            </ng-container>
          </td>
        </ng-container>

        <mat-menu #actionsMenu="matMenu">
          <button mat-menu-item (click)="editManualAccountMovements(actionRowClickedId)">
            <mat-icon>edit</mat-icon><span>Editar</span>
          </button>
          <button mat-menu-item (click)="deleteManualAccountMovements(actionRowClickedId)" style="color:#dc2626">
            <mat-icon style="color:#dc2626">delete</mat-icon><span>Eliminar</span>
          </button>
        </mat-menu>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
    <mat-paginator [length]="resultsLength" [pageSize]="pageSizeDefault"></mat-paginator>
  </div>

</div>
